
<section class="w3l-form-25">
  <div class="form-inner-cont">
    <div class="w3l-form-25">
        <h1>{{'Medical Records Data' | translate }}</h1>
        <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Patient Documents' | translate }}</h1>
    </div>
  </div>

<BR>
  <div id="w3l-appointment">
  <div  class="wrapper d-grid doctor-appointment">
    <form action="#" method="post" >
    <div class="appointment-form-field">
      <label style="width: 140px;">{{ 'Patient' | translate }}</label>
      <input type="text" name="pacode"  required="" style="width: 112px;" [(ngModel)]="patientcode" (change)="RertivePatient()" >
    <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"  (click)="OpenEmployeeDialog()"></span>

    <label id="w3l-appointment" class="appointment-form-field" style="width: 600px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{patientname}}</label>
    </div>
  </form>
  </div>
</div>
<BR>
  <div id="w3l-appointment">
    <div  class="wrapper d-grid doctor-appointment">
  <mat-tab-group animationDuration="2000ms" style="width: 1300px;">
    <!----***************Diomgraphic*********************--->
    <mat-tab label="Laboratory" style="width: 20%;">
    <BR>
      <div id="w3l-appointment">
        <div class="wrapper">
        <div class="d-grid doctor-appointment">
          <form action="#" method="post" >
        <table style="width: 1000px;table-layout: fixed;">
          <thead>
            <tr>
              <th class="grid-th" style="width: 5%;"[hidden]="true">{{'Doc.No. ' | translate }}</th>
              <th class="grid-th" style="width: 20%;" [hidden]="true">{{'Lab. Name' | translate }}</th>
              <th class="grid-th" style="width: 10%;" [hidden]="true">{{'Document Type' | translate }}</th>
              <th class="grid-th" style="width: 15%;">{{'Date of Investigation' | translate }}</th>
              <th class="grid-th" style="width: 32%;">{{'Description' | translate }}</th>
              <th class="grid-th" style="width: 8%;" >{{'Open' | translate }}</th>
              <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="grid-td-tr" style="align-content: center;" *ngFor="let sup of PatientDocumentsLabList; let i = index" >
                <td class="grid-td-th" data-column="Item Line" [hidden]="true">{{sup.doccode}} </td>
                <td class="grid-td-th" data-column="Item name" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item type" [hidden]="true" >{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item Datr">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item notes" style="cursor: pointer;">
                  <a (click)="openlink(sup)" target="_blank" style="color: rgb(0, 0, 218);">{{sup.docnotes}}</a>
                </td>
                <td >
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in;border-radius: 10%;"  />
                </a>
                </td>
                <td >
                  <button mat-raised-button  name="select" id="select" style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditLab(sup)" >{{'Edit' | translate}}</button>
                </td>
            </tr>
          </tbody>
        </table>
        <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordLab()" >{{'Add New Record' | translate}}</button>
        </form>
        </div>
        </div>
        </div>
    </mat-tab>
    <mat-tab label="Pathology" style="width: 20%;">
    <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
            <table style="width: 1000px;table-layout: fixed;">
            <thead>
              <tr>
                <th class="grid-th" style="width: 5%;" [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;"[hidden]="true" >{{'Pathology Type' | translate }}</th>
                <th class="grid-th" style="width: 10%;"[hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date of Investigation' | translate }}</th>
                <th class="grid-th" style="width: 32%;">{{'Discraption' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Open' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style=" align-content: center;" *ngFor="let sup of PatientDocumentsPathologyList; let i = index">
                <td class="grid-td-th" data-column="Item Line" [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor: pointer;">
                  <a (click)="openlink(sup)" target="_blank" style="color: rgb(0, 0, 218);">{{sup.docnotes}}</a>
                </td>
                <td class="grid-td-th" data-column="Item ID">
                  <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                    <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;" />
                  </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">
                  <button mat-raised-button  name="select" id="select" style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditPathology(sup)" >{{'Edit' | translate}}</button>
                </td>
              </tr>
            </tbody>
        </table>
        <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordPathology()" >{{'Add New Record' | translate}}</button>
        </form>
        </div>
        </div>
        </div>
    </mat-tab>
    <mat-tab label="Clinical imaging" style="width: 20%;">
      <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
              <table style="width: 1000px;table-layout: fixed;">

            <thead>
              <tr>

                <th class="grid-th" style="width: 5%;" [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;" [hidden]="true">{{'Image Type' | translate }}</th>
                <th class="grid-th" style="width: 10%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date' | translate }}</th>
                <th class="grid-th" style="width: 32%;" >{{'Discraption' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Open' | translate }}</th>

                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>

                  </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsImageList; let i = index">
                <td class="grid-td-th" data-column="Item Line" [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor: pointer;">
                  <a (click)="openlink(sup)" target="_blank" style="color: rgb(0, 0, 218);">{{sup.docnotes}}</a>

                </td>
                <td class="grid-td-th" data-column="Item ID">
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;"  />
                </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">

                  <button mat-raised-button  name="select" id="select" style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditImage(sup)" >{{'Edit' | translate}}</button>

                </td>
              </tr>

            </tbody>
              </table>
              <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordImage()" >{{'Add New Record' | translate}}</button>
            </form>
          </div>
          </div>
        </div>
    </mat-tab>

    <mat-tab label="Radiotherapy Docs" style="width: 20%;">
      <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
              <table style="width: 1000px;table-layout: fixed;">

            <thead>
              <tr>
                <th class="grid-th" style="width: 5%;"  [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;" [hidden]="true">{{'Technique' | translate }}</th>
                <th class="grid-th" style="width: 10%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date' | translate }}</th>
                <th class="grid-th" style="width: 32%;" >{{'Discraption' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Open' | translate }}</th>

                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>

                  </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsRadioList; let i = index">
                <td class="grid-td-th" data-column="Item Line"  [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor: pointer;">
                  <a (click)="openlink(sup)" target="_blank" style="color: rgb(0, 0, 218);">{{sup.docnotes}}</a>
                </td>
                <td class="grid-td-th" data-column="Item ID">
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;"  />
                </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">

                  <button mat-raised-button  name="select" id="select" style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditRadio(sup)" >{{'Edit' | translate}}</button>

                </td>
              </tr>

            </tbody>
              </table>
              <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordRadio()" >{{'Add New Record' | translate}}</button>
            </form>
          </div>
          </div>
        </div>
    </mat-tab>
    <mat-tab label="Genomic Testing" style="width: 20%;">
      <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
              <table style="width: 1000px;table-layout: fixed;">

            <thead>
              <tr>

                <th class="grid-th" style="width: 5%;"  [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;" >{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 10%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date of Investigation' | translate }}</th>
                <th class="grid-th" style="width: 32%;" >{{'Discraption' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Open' | translate }}</th>

                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>

                  </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsTestList; let i = index">
                <td class="grid-td-th" data-column="Item Line"  [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor: pointer;" >
                  <a (click)="openlink(sup)" target="_blank" style="color: rgb(0, 0, 218);">{{sup.docnotes}}</a>

                </td>
                <td class="grid-td-th" data-column="Item ID">
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;"  />
                </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">

                  <button mat-raised-button  name="select" id="select"  style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditTesting(sup)" >{{'Edit' | translate}}</button>

                </td>
              </tr>

            </tbody>
              </table>
              <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordTesting()" >{{'Add New Record' | translate}}</button>
            </form>
          </div>
          </div>
        </div>
    </mat-tab>
    <mat-tab label="Clinical photos" style="width: 20%;">
      <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
              <table style="width: 1000px;table-layout: fixed;">

            <thead>
              <tr>

                <th class="grid-th" style="width: 5%;"  [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 10%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date' | translate }}</th>
                <th class="grid-th" style="width: 32%;"  >{{'Discraption' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Open' | translate }}</th>

                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>

                  </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsPhotoList; let i = index">
                <td class="grid-td-th" data-column="Item Line"  [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor: pointer;" >
                  <a (click)="openlink(sup)" target="_blank">{{sup.docnotes}}</a>

                </td>
                <td class="grid-td-th" data-column="Item ID">
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;"  />
                </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">

                  <button mat-raised-button  name="select" id="select" style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditPhoto(sup)" >{{'Edit' | translate}}</button>

                </td>
              </tr>

            </tbody>
              </table>
              <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordPhoto()" >{{'Add New Record' | translate}}</button>
            </form>
          </div>
          </div>
        </div>
    </mat-tab>
    <mat-tab label="Others" style="width: 20%;">
      <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
              <table style="width: 1000px;table-layout: fixed;">

            <thead>
              <tr>

                <th class="grid-th" style="width: 5%;"  [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 10%;" >{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date' | translate }}</th>
                <th class="grid-th" style="width: 32%;" >{{'Discraption' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Image' | translate }}</th>

                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>

                  </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsOtherList; let i = index">
                <td class="grid-td-th" data-column="Item Line"  [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor: pointer;">
                  <a (click)="openlink(sup)" target="_blank">{{sup.docnotes}}</a>

                </td>
                <td class="grid-td-th" data-column="Item ID">
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;"  />
                </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">

                  <button mat-raised-button  name="select" id="select"  style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditOther(sup)" >{{'Edit' | translate}}</button>

                </td>
              </tr>

            </tbody>
              </table>
              <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordOther()" >{{'Add New Record' | translate}}</button>
            </form>
          </div>
          </div>
        </div>
    </mat-tab>
    <mat-tab label="Old Documents " style="width: 20%;">
      <BR>
        <div id="w3l-appointment">
          <div class="wrapper">
          <div class="d-grid doctor-appointment">
            <form action="#" method="post" >
              <table style="width: 1000px;table-layout: fixed;">

            <thead>
              <tr>

                <th class="grid-th" style="width: 5%;" [hidden]="true">{{'Doc.No. ' | translate }}</th>
                <th class="grid-th" style="width: 20%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 10%;" [hidden]="true">{{'Document Type' | translate }}</th>
                <th class="grid-th" style="width: 15%;">{{'Date' | translate }}</th>
                <th class="grid-th" style="width: 32%;">{{'Link' | translate }}</th>
                <th class="grid-th" style="width: 8%;">{{'Open' | translate }}</th>

                <th class="grid-th" style="width: 15%;">{{'Edit' | translate }}</th>

                  </tr>
            </thead>
            <tbody>
              <tr class="grid-td-tr" style="height: 7px;align-content: center;" *ngFor="let sup of PatientDocumentsTreatmnetList; let i = index">
                <td class="grid-td-th" data-column="Item Line" [hidden]="true">{{sup.doccode}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.docname}}</td>
                <td class="grid-td-th" data-column="Item ID" [hidden]="true">{{sup.doctype}}</td>
                <td class="grid-td-th" data-column="Item ID">{{sup.docdate}}</td>
                <td class="grid-td-th" data-column="Item ID" style="cursor:pointer;">
                  <a (click)="openlink(sup)" target="_blank">{{sup.docnotes}}</a>
                </td>
                <td class="grid-td-th" data-column="Item ID">
                <a [href]="openDialogViwer(sup)" [download]="true" target="_blank">
                  <img src = "assets/images/Zoom.jpg" alt="Item Image"   style="border-style: none;cursor: zoom-in; border-radius: 10%;"  />
                </a>
                </td>
                <td class="grid-td-th" data-column="Item Allocation">

                  <button mat-raised-button  name="select" id="select" style="background-color:#000a3e;color: #fcfcfc; height: 40px; font-size: 85%;font-weight: bolder;" (click)="openDialogTransEditTreatment(sup)" >{{'Edit' | translate}}</button>

                </td>
              </tr>

            </tbody>
              </table>
              <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="DialogNewRecordTreatment()" >{{'Add New Record' | translate}}</button>
            </form>
          </div>
          </div>
        </div>
    </mat-tab>
  </mat-tab-group>
    </div>
  </div>





<BR>
  <form class="example-button-container" style="width: 100%; text-align: center;" >
     <button mat-raised-button style="width:15%;background-color:#4abae7;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="Cloase_Dialog()">{{'Close' | translate}} </button>
  </form>

</section>






